<template>
    <div>
        <div class="detail-content school_business">
            <!-- Tiêu đề -->
            <div class="primarylists list-mobile">
                <div class="titles clear" :class="[{ titleMb: mobile }]" id="explore">
                    <img src="../../../static/images/icon-st.jpg" />
                    <div class="title l" style="text-transform: uppercase!important;">{{ $t("schoolBusiness.sloganFour") }}</div>
                </div>
                <!-- Checkbox: Hiển thị tất cả khóa học ở PC. Bao gồm đã hoàn thành -->
                <div class="lessons-done nqt__switch" v-if="!mobile">
                    <p>{{ $t("new.showCompletedCourse") }}</p>
                    <span class="menu-switch-school" :value="courseCompleted" :class="{ 'menu-switch-school-on': courseCompleted }" @click="switchCourses({courseCompleted: !courseCompleted, language: $lang()})"></span>
                </div>
            </div>
            <!-- Hiển thị danh sách tag level 1 -->
            <div class="primarymenu container primarymenu-add" :class="[ { boxout: mobile }, { 'primarymenu-mb': mobile }, { nqt__mb_ct: mobile }]">
                <ul class="clear" :class="{ boxin: mobile }">
                    <li class="setCourse" @click="setCourse('/home/setSelfMenu')">
                        <img src="../../../static/images/settings.png" alt="settings" />
                    </li>
                    <li class="SchoolBusiness_menu_li" v-for="item in menuOne" :key="item.id" :class="{active: levelOne == item.id}" @click='changeTagLvOne({tagID: item.id, language: $lang(), name: $t("schoolBusiness.all")})'>
                        {{ item.name }}
                    </li>
                </ul>
                <!-- Checkbox: Hiển thị tất cả khóa học ở mobile. Bao gồm đã hoàn thành -->
                <div class="lessons-done" v-if="mobile">
                    <p>{{ $t("new.showCompletedCourse") }}</p>
                    <span class="menu-switch-school" :value="courseCompleted" :class="{ 'menu-switch-school-on': courseCompleted }" @click="switchCourses({courseCompleted: !courseCompleted, language: $lang()})"></span>
                </div>
            </div>
            <!-- Hiển thị danh sách tag level 2 -->
            <div class="secondmenu container">
                <ul class="clear" v-if="menuTwo.length">
                    <li class="SchoolBusiness_menues_li" v-for="item in menuTwo" :key="item.id" :class="{nqt__active: levelTwo == item.id}" @click='changeTagLvTwo({tagID: item.id, language: $lang(), name: $t("schoolBusiness.all")})'>
                        {{ item.name }}
                    </li>
                </ul>
            </div>
            <!-- Danh sách khóa học -->
            <div class="primarylists">
                <div class="lessons">
                    <ul class="clear" :class="{nqt__mb_ct_list: mobile}">
                        <li v-for="(item, index) in dataRender" :key="item.id">
                            <div v-if="!item.isUrl">
                                <div class="img vaa">
                                    <img :src='item.courseCover == undefined || item.courseCover == null || item.courseCover == "" ? "../../../static/images/temppic.jpg" : item.courseCover' @click="goAicourse(item.courseId)" />
                                </div>
                                <div class="lessontitle" :title="item.courseName" style="-webkit-box-orient: vertical;" @click="goAicourse(item.courseId)">
                                    {{ item.courseName }}
                                </div>
                                <div class="introduce-new" style="-webkit-box-orient: vertical;" @click="goAicourse(item.courseId)" v-html="item.synopsis"></div>
                                <div class="like-ps" @click="handleLike(index, item)">
                                    <div class="islike">
                                        <div>
                                            <img v-if="item.isLike == 0" src="../../../static/images/good2.png" />
                                            <img v-if="item.isLike == 1" src="../../../static/images/good1.png" />
                                            <span>{{ item.likeNum }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="hot-position">
                                    <div v-if="item.isHot == '1'" class="ishot-r">Hot</div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="img vaa">
                                    <span v-html="item.courseCover"></span>
                                </div>
                                <div class="lessontitle" :title="item.courseName" style="-webkit-box-orient: vertical;" @click="goAicourse(item.courseId)">
                                    {{ item.courseName }}
                                </div>
                                <div class="like-ps" @click="handleLike(index, item)">
                                    <div class="islike">
                                        <div>
                                            <img v-if="item.isLike == 0" src="../../../static/images/good2.png" />
                                            <img v-if="item.isLike == 1" src="../../../static/images/good1.png" />
                                            <span>{{ item.likeNum }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="hot-position">
                                    <div v-if="item.isHot == '1'" class="ishot-r">Hot</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Phân trang -->
            <div style="text-align: center; margin-top: 10px;" v-if="myCourses.length > 0">
                <el-pagination background @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" layout="prev, pager, next" :total="myCourses.length"></el-pagination>
            </div>
            <!-- Loading -->
            <loading class="loading--lesson" :showLoading="loading" />
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        name: "SchoolBusiness",
        components: {
            loading, 
        },
        data() {
            return {
                pageSize: 5,
            };
        },
        async mounted() {
            this.$autoLogin().then(
                async () => {
                    this.init({ tagID: null, language: this.$lang(), name: this.$t("schoolBusiness.all") });
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        computed: {
            // Render dữ liệu
            dataRender() {
                this.pageSize = this.mobile ? 4 : 15;

                if (this.myCourses.length) {
                    let result = this.myCourses.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
                    return result;
                }
                return [];
            },
            // Lấy dữ liệu từ store
            ...mapState({
                myCourses: (state) => state.schoolBussiness.myCourses,
                menuOne: (state) => state.schoolBussiness.menuOne,
                menuTwo: (state) => state.schoolBussiness.menuTwo,
                levelOne: (state) => state.schoolBussiness.levelOne,
                levelTwo: (state) => state.schoolBussiness.levelTwo,
                courseCompleted: (state) => state.schoolBussiness.courseCompleted,
                page: (state) => state.schoolBussiness.page,
                loading: (state) => state.schoolBussiness.loading,
                mobile: (state) => state.header.mobile,
            }),
        },
        methods: {
            handleCurrentChange(val) {
                this.setPage(val);
            },
            goAicourse: function (courseId) {
                // Đi đến chi tiết khóa học
                this.$router.push({
                    name: "Aicourse",
                    query: {
                        buyCourseId: JSON.stringify(courseId),
                        buyCollegeId: JSON.stringify(1),
                    },
                });
            },
            handleLike: function (index, item) {
                if (item.isLike == 1) {
                    this.dislike({ item: item, index: index });
                } else {
                    this.like({ item: item, index: index });
                }
            },
            setCourse: function (url) {
                this.$router.push({
                    path: url,
                    query: {
                        fromPagetype: JSON.stringify(2),
                        isPcflag: JSON.stringify(0),
                    },
                });
            },
            ...mapActions("schoolBussiness", ["init", "changeTagLvOne", "changeTagLvTwo", "switchCourses", "dislike", "like"]),
            ...mapMutations("schoolBussiness", ["setPage"]),
        },
    };
</script>
<style scoped>
    .primarylists.list-mobile {
        position: relative;
    }
    .nqt__switch {
        position: absolute;
        right: 10px;
        top: 5px;
        padding: 0 !important;
        margin-left: 10px !important;
        margin-bottom: 10px !important;
    }
    .nqt__mb_ct .SchoolBusiness_menu_li,
    .nqt__mb_ct .setCourse {
        margin-top: 5px !important;
    }
    .like-ps {
        cursor: pointer !important;
    }
    .nqt__active {
        background: #00a8ff !important;
        color: #fff !important;
        /* border: none !important; */
    }
    .main {
        padding-top: 60px;
    }

    a {
        text-decoration: none;
        color: white;
        -webkit-tap-highlight-color: white;
        -webkit-user-select: none;
        -moz-user-focus: none;
        -moz-user-select: none;
    }
    .l {
        float: left;
    }
    .r {
        float: right;
    }
    .clear::after {
        content: ".";
        display: block;
        clear: both;
        height: 0;
        visibility: hidden;
    }
    .container {
        width: 100%;
        margin: 0 auto;
    }
    @media screen and (min-width: 1000px) and (max-width: 1200px) {
        .container {
            width: 1000px;
        }
    }
    @media screen and (min-width: 800px) and (max-width: 1000px) {
        .container {
            width: 800px;
        }
    }
    @media screen and (min-width: 600px) and (max-width: 800px) {
        .container {
            width: 600px;
        }
    }
    @media screen and (max-width: 600px) {
        .container {
            width: 400px;
        }
    }
    .swiper-container {
        margin-bottom: 20px;
        /* overflow: hidden;
  height: 450px; */
    }
    .swiper-container img {
        width: 100%;
    }

    .main {
        padding-top: 40px;
        /* background: #121212; */
        /*color: white;*/
    }

    .primarymenu {
        /*padding-bottom: 15px;*/
        position: relative;
    }
    .primarymenu-add {
        height: auto !important;
        overflow: hidden;
        margin-top: 0 !important;
    }

    .primarymenu ul {
        margin-right: 10px;
        margin-left: 10px;
    }
    .primarymenu .showAllCourse {
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
    }
    .primarymenu .showAllCourse img {
        width: 19px;
    }
    .primarymenu ul li {
        float: left;
        padding: 5px 15px;
        margin: 0 20px 0 0;
        background: #e0e0e0;
        color: #333;
        border-radius: 5px;
        cursor: pointer;
        margin-bottom: 10px;
        font-size: 14px;
    }
    .primarymenu ul li:hover {
        background: #00a8ff;
        color: #fff;
    }
    .primarymenu ul li.active {
        background: #00a8ff;
        color: #fff;
        border: none;
    }
    .secondmenu ul {
        margin: 0 10px;
        padding: 20px 0 10px;
        background: #eee;
        border-radius: 5px;
    }
    .secondmenu ul li {
        float: left;
        padding: 5px 25px;
        background: #fff;
        margin: 0 10px 10px;
        border-radius: 20px;
        border: 1px solid #ccc;
        cursor: pointer;
        color: #333;
    }
    .secondmenu ul li:hover {
        background: #00a8ff;
        color: white;
        border: 1px solid #fff;
    }
    .secondmenu ul li.active {
        background: #00a8ff;
        border: none;
        color: white;
    }

    .change {
        cursor: pointer;
        margin-bottom: 5px;
        margin-top: 15px;
    }
    .change:hover {
        color: #02adff;
    }
    .change.mb {
        margin: 0 !important;
    }
    .change div {
        padding: 0 5px;
        font-size: 14px;
    }
    .change i {
        font-style: normal;
        font-weight: bold;
        margin-right: 3px;
    }

    .lists {
        min-height: 200px;
    }
    .lists ul {
        transform: translateX(5px);
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-around; */
    }
    .lists ul li {
        width: 190px;
        height: 170px;
        box-sizing: border-box;
        margin-right: 10px;
        margin-bottom: 30px;
        overflow: hidden;
        background: #333;
        border-radius: 5px;
        overflow: hidden;
    }
    .lists ul li .img {
        height: 100px;
        width: 100%;
        overflow: hidden;
    }
    .lists ul li .img img {
        width: 100%;
        height: 100%;
        transition: all 0.25s ease-in-out;
        -moz-transition: all 0.25s ease-in-out;
        -webkit-transition: all 0.25s ease-in-out;
        -o-transition: all 0.25s ease-in-out;
    }
    .lists .lessontitle {
        color: white;
        margin: 8px 0 3px;
        padding: 0px 10px;
        font-size: 15px;
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
    .lists .lessontitle:hover {
        color: #02adff;
        cursor: pointer;
    }
    .lists .introduce {
        padding: 0 10px;
        color: #999;
        font-size: 12px;
        /* 1行溢出隐藏 */
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 1;
        overflow: hidden;
    }

    .lists .islike {
        float: right;
        margin: 2px 10px 3px 0px;
        color: #f8f8f8;
        font-size: 10px;
        cursor: pointer;
        overflow: hidden;
    }

    .lists.islike span {
        float: right;
    }

    .footer {
        padding: 50px 0 30px 0;
        color: white;
        text-align: center;
        background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg) no-repeat center bottom;
        background-size: cover;
    }
    .footer .line1 {
        font-size: 46px;
    }
    .footer .line2 {
        font-size: 14px;
        margin-bottom: 30px;
    }
    .footer .line3 {
        display: inline-block;
        padding: 5px 50px;
        border: 1px solid white;
        border-radius: 20px;
    }
    .footer .line3:hover {
        background: white;
        color: black;
        cursor: pointer;
    }
    .swiper_bottom_shade {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 10;
        height: 200px;
        width: 100%;
        background: -webkit-gradient(linear, left top, left bottom, from(rgba(224, 224, 219, 0)), to(#fff));
        background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
        background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
    }
    .primarymenu ul li.setCourse {
        background: #eb2f06;
        margin-right: 10px;
        /*margin-left:0px;*/
        padding: 5px;
    }
    .setCourse img {
        width: 19px;
    }
    .boxout .boxin {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
    }
    .boxout .boxin li.SchoolBusiness_menu_li {
        box-sizing: border-box;
    }
    ::-webkit-scrollbar {
        display: none;
    }
    .vaa :hover {
        transform: scale(1.05, 1.05);
        cursor: pointer;
    }
    .down_laa {
        -webkit-text-stroke-width: 2px;
        color: #999;
    }
    .up_laa {
        -webkit-text-stroke-width: 2px;
        color: #00d3ff;
    }
    .oaa {
        -webkit-text-stroke-width: 2px;
        color: #ffb821;
    }

    /* custom */
    .lessons {
        margin-top: 0 !important;
    }
    .secondmenu.container {
        margin-bottom: 10px !important;
        width: 100%;
    }
    .titleMb {
        padding: 0 !important;
        margin-bottom: 10px !important;
    }
    .lesson--done {
        border: red solid;
    }
    .lessons--cheked {
        padding-bottom: 10px;
        padding-right: 10px;
    }
    .lessons--cheked input {
        vertical-align: middle;
        margin-top: 0;
        size: 19px;
    }
    .lessons--cheked span {
        vertical-align: middle;
        margin-top: 0;
        color: #666;
        margin-left: 5px;
        font-size: 13px;
    }
    .lessons-done {
        display: flex;
        justify-content: flex-end;
        padding-right: 30px;
    }
    .lessons-done p {
        padding-top: 5px;
        padding-right: 5px;
    }
    .menu-switch-school {
        display: block;
        position: relative;
        width: 46px;
        height: 27px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch-school:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 25px;
        border-radius: 15px;
        background-color: #fdfdfd;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch-school:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-school-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-school-on:before {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-school-on:after {
        transform: translateX(20px);
    }
    .primarymenu-mb {
        height: auto !important;
    }
    .primarylists .lessons .introduce {
        -webkit-box-orient: vertical !important;
    }
    .vn .primarylists .lessons .introduce {
        -webkit-box-orient: vertical !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/SchoolBusiness/SchoolBusiness.vue